/**
 * Gillamoos-Termine im Browser — Spiegel von App\Gillamoos\FairDates.
 *
 * Der Countdown bekommt Start/Ende als ISO-Werte vom Server. Kommt die Seite
 * aus dem Pimcore-Full-Page-Cache, können diese Werte abgelaufen sein; dann
 * rechnet der Controller mit diesen Helfern selbst weiter, statt neu zu laden.
 *
 * Sechs Zeilen doppelt zu halten ist billiger als ein Endpoint für eine Regel,
 * die sich seit 1313 nicht geändert hat.
 */

/** Festwoche: Donnerstag vor dem ersten Sonntag im September, 5 Tage lang. */
export const FAIR_DAYS = 5;

/** Donnerstag vor dem ersten Sonntag im September des Jahres. */
export function fairStartForYear(year) {
    const firstSept = new Date(year, 8, 1);
    const firstSunday = 1 + ((7 - firstSept.getDay()) % 7);

    return new Date(year, 8, firstSunday - 3);
}

/** Ende des Fests: Dienstag 00:00 nach dem Montag. */
export function fairEnd(start) {
    return new Date(start.getTime() + FAIR_DAYS * 864e5);
}

/** Der nächste Start — nach dem Ende das Folgejahr. */
export function nextFairStart(now) {
    const year = now.getFullYear();
    const start = fairStartForYear(year);

    return now >= fairEnd(start) ? fairStartForYear(year + 1) : start;
}

/**
 * "03. – 07. September 2027", über den Monatswechsel "31. August – 04. September 2028".
 * Gleiches Format wie GillamoosHero::action.
 */
export function formatFairRange(start) {
    const last = new Date(start.getTime() + (FAIR_DAYS - 1) * 864e5);
    const day = (d) => String(d.getDate()).padStart(2, '0');
    const month = (d) => d.toLocaleDateString('de-DE', { month: 'long' });
    const startMonth = start.getMonth() === last.getMonth() ? '' : ` ${month(start)}`;

    return `${day(start)}.${startMonth} – ${day(last)}. ${month(last)} ${last.getFullYear()}`;
}
